import { Icon_default } from "./chunk-3BD6RCWY.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Spinner/Spinner.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var SPINNER_CLASSNAME_MAP = {
  variant: {
    primary: "pd-text-primary-500",
    dim: "pd-text-dim-500",
    white: "pd-text-white"
  },
  size: {
    sm: "pd-size-5",
    md: "pd-size-8",
    lg: "pd-size-12",
    xl: "pd-size-16"
  }
};
var Spinner = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "primary",
      size = "md",
      screenReaderLabel,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "size", "screenReaderLabel", "className"]);
  return /* @__PURE__ */React.createElement(Icon_default, __spreadValues({
    ref,
    icon: "spinner",
    className: clsx("pd-spinner", SPINNER_CLASSNAME_MAP.variant[variant], SPINNER_CLASSNAME_MAP.size[size], className),
    "aria-busy": "true",
    "aria-live": "polite",
    "aria-label": screenReaderLabel
  }, rest));
});
var Spinner_default = Spinner;
export { SPINNER_CLASSNAME_MAP, Spinner_default };